import Dialog from '@stimulus-components/dialog'
import { createKeyListener } from '~/utils/keyboard'
import { stimulus } from '~/init'

export default class DialogController extends Dialog {
  static values = {
    closeable: { type: Boolean, default: true },
    storableState: { type: Boolean, default: false },
    ...Dialog.values
  }

  static targets = Dialog.targets

  connect () {
    if (this.storableStateValue && this.isStoredClosed()) {
      this.openValue = false
    }

    super.connect()

    if (this.closeableValue) {
      this._onKeydown = createKeyListener('Escape', () => this.close(), () => this.closeableValue)
      document.addEventListener('keydown', this._onKeydown)
    }
  }

  open () {
    if (this.closeableValue) {
      this.openValue = true
      super.open()
    } else {
      setTimeout(() => {
        this.openValue = true
        super.open()
      }, 500)
    }
  }

  close () {
    if (!this.closeableValue) return

    this.storeClosedState()
    this.openValue = false
    super.close()
  }

  backdropClose (event) {
    if (!this.closeableValue) return

    this.storeClosedState()
    this.openValue = false
    super.backdropClose(event)
  }

  disconnect () {
    super.disconnect()
    if (this._onKeydown) {
      document.removeEventListener('keydown', this._onKeydown)
    }
  }

  storeClosedState () {
    if (this.storableStateValue) {
      window.localStorage.setItem(this.storeKey(), 'true')
    }
  }

  isStoredClosed () {
    return window.localStorage.getItem(this.storeKey()) === 'true'
  }

  storeKey () {
    return `modal_closed:${window.location.pathname}`
  }
}

stimulus.register('dialog', DialogController)
